package editor

import editor.structure.StructureElement
import three.js.Plane
import three.js.Vector3

object PlaneManager {
    /**
     * Construct a plane that is aligned with the intersection face.
     */
    fun constructIntersectionPlane(
        target: StructureElement,
        localNormal: Vector3,
        intersectionPoint: Vector3,
    ): Plane {
        val worldNormal = localNormal.clone().applyQuaternion(target.object3D.quaternion).normalize()
        val constant = -worldNormal.dot(intersectionPoint).toDouble()
        val plane = Plane(worldNormal, constant)
        return plane
    }
}